<template>
  <v-dialog v-model="showModal" width="500" persistent scrollable>
    <v-card>
      <v-card-title class="headline" primary-title>Create Roud</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form @submit.prevent="save">
          <v-text-field
            v-model="name"
            label="Name"
            v-validate="'required|max:50'"
            :error-messages="errors.collect('name')"
            data-vv-name="name"
          ></v-text-field>
          <v-layout row wrap>
            <v-flex xs6>
              <date-picker-custom
                :title="'Start Date'"
                :date="start_date"
                @update-date="updateStartDate"
              />
            </v-flex>
            <v-flex xs6>
              <date-picker-custom
                :title="'End Date'"
                :date="end_date"
                @update-date="updateEndDate"
              />
            </v-flex>
          </v-layout>

          <v-textarea
            v-model="description"
            v-validate="'max:190'"
            :error-messages="errors.collect('description')"
            data-vv-name="description"
            label="Description"
            rows="2"
          ></v-textarea>
          <label for="clone">Clone contacts</label>
          <v-switch
            v-model="clone"
            :label="clone ? `Clone contacts` : ` Not Clone`"
          ></v-switch>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="$emit('close-modal-create-round')">Close</v-btn>
        <v-btn color="primary" @click="save">
          Save
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DatePickerCustom from '@/components/client/rounds/commons/DatePickerCustom.vue';

export default {
  components: {
    DatePickerCustom
  },
  props: {
    showModal: {
      type: Boolean,
      default: false      
    },
  },
  data () {
    return {
      name: '',
      clone: false,
      description: null,
      start_date: new Date().toISOString().substr(0, 10),
      /* Default value add 7 days for end_date survey */
      end_date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10)
    };
  },
  methods: {
    ...mapActions(['setSnackbar', 'setLoading']),
    updateStartDate (value) {
      this.start_date = value;
    },
    updateEndDate (value) {
      this.end_date = value;
    },
    save () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.setLoading(true);
          const url = '/rounds';
          const payload = {
            survey_id: this.$route.params.survey_id,
            name: this.name,
            start_date: this.start_date,
            end_date: this.end_date,
            description: this.description,
            clone: this.clone
          };
          window.axios.post(url, payload).then((response) => {
            this.$emit('add-round', response.data.data);
            this.$emit('close-modal-create-round');
            this.setSnackbar({
              show: true,
              color: 'green',
              text: 'Round added Successfully'
            });
            this.setLoading(false);
          }).catch(error => {
            this.setSnackbar({
              show: true,
              color: 'error',
              text: 'Server Error'
            });
            this.setLoading(false);
          });
        } else {
          this.setSnackbar({
            show: true,
            color: 'info',
            text: 'Check the form, please.'
          });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/client/rounds/modals/CreateRound.vue